import { render, staticRenderFns } from "./NotificationEditorPartial.vue?vue&type=template&id=1d98fb06&scoped=true&"
import script from "./NotificationEditorPartial.vue?vue&type=script&lang=js&"
export * from "./NotificationEditorPartial.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEditorPartial.vue?vue&type=style&index=0&id=1d98fb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98fb06",
  null
  
)

export default component.exports